import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectManagerListModalComponent } from 'src/app/Modules/idms/components/project-manager/modals/project-manager-list-modal/project-manager-list-modal.component';
import { IceDatabaseService } from 'src/app/services/ice-database.service';
import { IceDatabaseDetail, TableRefrences } from '../../models/ice-database.model';

@Component({
    selector: 'app-ice-database-sidebar',
    templateUrl: './ice-database-sidebar.component.html',
    styleUrls: ['./ice-database-sidebar.component.scss'],
})
export class IceDatabaseSidebarComponent implements OnInit {
    @Input() databaseDetails: IceDatabaseDetail[];
    selectedTableData: IceDatabaseDetail;
    copySelectedTableData: IceDatabaseDetail;
    searchInput: string;
    selectedTable: string;
    searchTableInput: string;
    parentTableList: TableRefrences[];
    childTableList: TableRefrences[];
    copyParentTableList: TableRefrences[];
    copyChildTableList: TableRefrences[];

    constructor(
        private iceDatabaseService: IceDatabaseService,
        private model: NgbModal
    ) {}

    ngOnInit(): void {
        this.handleSubscription();
    }

    handleSubscription(): void {
        this.iceDatabaseService.selectedTableItems.subscribe((res) => {
            if (res && res.tableData) {
                this.selectedTableData = { name: res.tableData.name, tableList: res.tableData.tableList.slice() };
                this.copySelectedTableData = { name: res.tableData.name, tableList: res.tableData.tableList.slice(0, 5) };
                if (res.selectedTable) {
                    this.iceDatabaseService.selectedTableName.next({ tableName: res.selectedTable });
                } else {
                    this.selectedTable = null;
                }
            } else {
                this.selectedTableData = null;
                this.selectedTable = null;
            }
        });

        this.iceDatabaseService.selectedTableName.subscribe((res) => {
            if (res && res.tableName) {
                this.selectedTable = res.tableName;

                let tableIndex = this.copySelectedTableData.tableList.findIndex((p) => p.name == res.tableName);
                if (tableIndex >= 0) {
                    this.copySelectedTableData.tableList.splice(tableIndex, 1);
                }

                var data = this.selectedTableData.tableList.filter((item) => item.name === res.tableName);
                if (data.length) {
                    this.copySelectedTableData.tableList.unshift(data[0]);
                    if (this.copySelectedTableData.tableList.length > 5) {
                        this.copySelectedTableData.tableList = this.copySelectedTableData.tableList.slice(0, 5);
                    }
                } else {
                    const data = this.iceDatabaseService.databaseDetails.find((category) => category.tableList.some((table) => table.name === res.tableName));
                    this.iceDatabaseService.selectedTableItems.next({ tableData: data, selectedTable: res.tableName });
                }

                this.copyParentTableList = this.parentTableList = this.iceDatabaseService.tableRefrences.filter(
                    (x) => x.childTableName === res.tableName && x.childColumnName
                );
                this.copyChildTableList = this.childTableList = this.iceDatabaseService.tableRefrences.filter((x) => x.parentTableName === res.tableName);
            }
        });
    }

    searchResult(event): void {
        if (this.searchInput.trim() !== '') {
            this.copySelectedTableData.tableList = this.selectedTableData.tableList.filter((item) => {
                return (item.name !== undefined ? item.name : '').toLowerCase().includes(this.searchInput.trim().toLowerCase());
            });
        } else {
            this.copySelectedTableData.tableList = [...this.selectedTableData.tableList];
        }
        this.copySelectedTableData.tableList.splice(5);
    }

    selectedTableItem(selectedItem: IceDatabaseDetail): void {
        this.iceDatabaseService.selectedTableItems.next({ tableData: selectedItem });
    }

    selectedTableName(tableName: string): void {
        this.iceDatabaseService.selectedTableName.next({ tableName: tableName });
    }

    table_moreData(): void {
        let dialogRef = this.model.open(ProjectManagerListModalComponent, {
            windowClass: 'custom-modal',
        });
        dialogRef.componentInstance.projectsList = this.selectedTableData.tableList;
        dialogRef.componentInstance.currentInstance = this.selectedTableData.name;
        dialogRef.componentInstance.type = 'IceDatabase';

        dialogRef.result
            .then((resp) => {
                if (resp) {
                    this.iceDatabaseService.selectedTableName.next({ tableName: resp.name });
                }
            })
            .catch((e) => {
                console.warn(e);
            });
    }

    searchTableResult(event): void {
        if (this.searchTableInput.trim() !== '') {
            this.copyParentTableList = this.parentTableList.filter((item) => {
                return (item.parentTableName ?? '').toLowerCase().includes(this.searchTableInput.trim().toLowerCase());
            });
            this.copyChildTableList = this.childTableList.filter((item) => {
                return (item.childTableName ?? '').toLowerCase().includes(this.searchTableInput.trim().toLowerCase());
            });
        } else {
            this.copyParentTableList = [...this.parentTableList];
            this.copyChildTableList = [...this.childTableList];
        }
    }

    backToHome(): void {
        this.iceDatabaseService.selectedTableItems.next(null);
    }
}
